import React from 'react';

import styled from 'styled-components';

import IconArrowRight from 'components/icons/arrow-right';

const MenuCard = styled.button`
  background-color: ${Styles.color.primary};
  border-radius: 9999rem;
  appearance: none;
  border: 0;
  cursor: pointer;
  height: 40px;
  user-select: none;
  width: 40px;

  &:active {
    transform: scale(0.95);
    transition: transform 200ms ease-out;
  }
  &:hover {
    background-color: ${Styles.color.primaryHover};
  }

  svg {
    fill: ${Styles.color.white};
    height: 14px;
    left: 1px;
    position: relative;
    top: 1.5px;
  }
`;

const MenuCardButton = props => (
  <MenuCard {...props}>
    <IconArrowRight />
  </MenuCard>
);

export default MenuCardButton;
